const VIBRA_REVEAL_SELECTOR = '[data-vibra-reveal]';

const vibraReduceMotion = window.matchMedia(
  '(prefers-reduced-motion: reduce)'
);

let vibraRevealObserver = null;


/* =========================================================
   HELPERS
   ========================================================= */

function vibraIsDesignMode() {
  return Boolean(
    window.Shopify &&
    window.Shopify.designMode
  );
}


function vibraGetRevealElements(root = document) {
  const elements = [];

  if (
    root instanceof Element &&
    root.matches(VIBRA_REVEAL_SELECTOR)
  ) {
    elements.push(root);
  }

  if (
    root === document ||
    root instanceof Element
  ) {
    elements.push(
      ...root.querySelectorAll(
        VIBRA_REVEAL_SELECTOR
      )
    );
  }

  return elements;
}


/* =========================================================
   OBSERVER
   ========================================================= */

function vibraGetObserver() {

  if (vibraRevealObserver) {
    return vibraRevealObserver;
  }

  vibraRevealObserver =
    new IntersectionObserver(
      (entries, observer) => {

        entries.forEach((entry) => {

          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add(
            'is-visible'
          );

          observer.unobserve(
            entry.target
          );

        });

      },
      {
        threshold: 0.16,
        rootMargin: '0px 0px -6% 0px'
      }
    );

  return vibraRevealObserver;
}


/* =========================================================
   INIT
   ========================================================= */

function vibraInitReveal(root = document) {

  const elements =
    vibraGetRevealElements(root);

  if (!elements.length) {
    return;
  }


  /*
    Dentro del editor de Shopify:
    nunca ocultamos contenido.

    Esto permite modificar colores,
    tamaños, columnas, textos, etc.
    viendo el resultado inmediatamente.
  */

  if (
    vibraIsDesignMode() ||
    vibraReduceMotion.matches
  ) {

    elements.forEach((element) => {

      element.classList.add(
        'is-visible'
      );

      element.removeAttribute(
        'data-vibra-observed'
      );

    });

    return;
  }


  const observer =
    vibraGetObserver();


  elements.forEach((element) => {

    if (
      element.hasAttribute(
        'data-vibra-observed'
      )
    ) {
      return;
    }

    element.setAttribute(
      'data-vibra-observed',
      ''
    );

    observer.observe(element);

  });

}


/* =========================================================
   FIRST LOAD
   ========================================================= */

function vibraBoot() {
  vibraInitReveal(document);
}


if (document.readyState === 'loading') {

  document.addEventListener(
    'DOMContentLoaded',
    vibraBoot,
    { once: true }
  );

} else {

  vibraBoot();

}


/* =========================================================
   SHOPIFY THEME EDITOR
   ========================================================= */

document.addEventListener(
  'shopify:section:load',
  (event) => {
    vibraInitReveal(event.target);
  }
);


document.addEventListener(
  'shopify:block:select',
  (event) => {
    vibraInitReveal(event.target);
  }
);


/* =========================================================
   DYNAMIC CONTENT
   Section Rendering API / DOM replacements
   ========================================================= */

const vibraMutationObserver =
  new MutationObserver((mutations) => {

    mutations.forEach((mutation) => {

      mutation.addedNodes.forEach((node) => {

        if (!(node instanceof Element)) {
          return;
        }

        vibraInitReveal(node);

      });

    });

  });


vibraMutationObserver.observe(
  document.documentElement,
  {
    childList: true,
    subtree: true
  }
);


/* =========================================================
   ACCESSIBILITY
   ========================================================= */

vibraReduceMotion.addEventListener(
  'change',
  () => {
    vibraInitReveal(document);
  }
);